import { render } from "./RegisterWarrantyBanner.vue?vue&type=template&id=5b1abd2b&scoped=true&ts=true"
import script from "./RegisterWarrantyBanner.vue?vue&type=script&lang=ts"
export * from "./RegisterWarrantyBanner.vue?vue&type=script&lang=ts"

import "./RegisterWarrantyBanner.vue?vue&type=style&index=0&id=5b1abd2b&lang=scss&scoped=true"

import exportComponent from "E:\\agent\\azdo\\CI\\a1-CI\\_work\\102\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b1abd2b"]])

export default __exports__